import { react2angular } from '@/react-tools/react2angular';
import { EnvironmentProvider } from '@/core/environments/useEnvironment';
import { TableSettingsProvider } from '@/core/components/datatables/components/useTableSettings';
import { SearchBarProvider } from '@/core/components/datatables/components/SearchBar';
import type { Environment } from '@/core/environments/types';

import {
  ContainersDatatable,
  ContainerTableProps,
} from './ContainersDatatable';

interface Props extends ContainerTableProps {
  endpoint: Environment;
}

export function ContainersDatatableContainer({
  endpoint,
  tableKey = 'containers',
  ...props
}: Props) {
  const defaultSettings = {
    autoRefreshRate: 0,
    truncateContainerName: 32,
    hiddenQuickActions: [],
    hiddenColumns: [],
    pageSize: 10,
    sortBy: { id: 'state', desc: false },
  };

  return (
    <EnvironmentProvider environment={endpoint}>
      <TableSettingsProvider defaults={defaultSettings} storageKey={tableKey}>
        <SearchBarProvider storageKey={tableKey}>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <ContainersDatatable {...props} />
        </SearchBarProvider>
      </TableSettingsProvider>
    </EnvironmentProvider>
  );
}

export const ContainersDatatableAngular = react2angular(
  ContainersDatatableContainer,
  [
    'endpoint',
    'isAddActionVisible',
    'dataset',
    'onRefresh',
    'isHostColumnVisible',
    'tableKey',
  ]
);
